var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.066 4.13a1.23 1.23 0 0 0-1.712 0 1.17 1.17 0 0 0 0 1.677L4.256 9.63a.5.5 0 0 0 .725-.027l6.665-7.58a1.17 1.17 0 0 0 0-1.677 1.23 1.23 0 0 0-1.712 0L4.633 6.376z"
})));
export default SvgUnion;